// hooks/usePortfolioActions.js
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchDetailedPortfolioObjects } from "../../api/portfolioApi";
import { extractEtfsFromPortfolio } from "../SmaV2/smaHelpers";
import useSma from "../SmaV2/useSma";
import { useEnsureTickersLoaded } from "../../hooks/useEnsureTickersLoaded";
import {setExistingPortfolioBuilderContext} from "../../store/slices/builder.slice";


const usePortfolioActions = ({portfolio}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isPublic = useSelector(state => state.public.isPublicAccess);

  const [currentAction, setCurrentAction] = useState(null);
  const [fetchComplete, setFetchComplete] = useState(false);
  const [fetchedPortfolioId, setFetchedPortfolioId] = useState(null);

  const { initializeWithTemplate } = useSma();

  const fullPortfolioObject = useSelector(state =>
    state.portfolios.items.find(p => p.id === fetchedPortfolioId)
  );

  const { tickers } = useEnsureTickersLoaded(
    fullPortfolioObject?.symbols ? Object.keys?.(fullPortfolioObject?.symbols) : []
  );

  const fetchPortfolio = (portfolioId) => {
    dispatch(fetchDetailedPortfolioObjects([portfolioId])).then(() => {
      setFetchComplete(true);
    });
  };

  const handlePortfolioAction = (action) => {
    setCurrentAction(action);
    setFetchedPortfolioId(portfolio.id);
    fetchPortfolio(portfolio.id);
  };

  useEffect(() => {
    if (fetchComplete) {
      setFetchComplete(false);
      switch (currentAction) {

        case "updatePositions":
          dispatch(setExistingPortfolioBuilderContext(fullPortfolioObject));
          navigate("/builders/portfolio");
          break;

        case "createSma":
          const etfs = extractEtfsFromPortfolio(fullPortfolioObject.symbols, tickers);
          if (!etfs) return;
          initializeWithTemplate(etfs);
          let url = isPublic ? "/public/builders/sma" : "/builders/sma";
          url += "?view=preview";
          navigate(url);
          break;
        default:
          break;
      }
    }
  }, [fetchComplete, fullPortfolioObject, navigate]);

  return {
    handlePortfolioAction,
    currentAction,
    setCurrentAction,
    fullPortfolioObject,
  };
};

export default usePortfolioActions;
